// extracted by mini-css-extract-plugin
export default {"card":"customer-orders-section_card__2oc4t","head":"customer-orders-section_head__Q01Py","title":"customer-orders-section_title__NSSpI"};